/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_map = /** @type {(inputs: {}) => string} */ () => {
	return `Mapa`
};

const da_map = /** @type {(inputs: {}) => string} */ () => {
	return `Kort`
};

const de_map = /** @type {(inputs: {}) => string} */ () => {
	return `Karte`
};

const en_map = /** @type {(inputs: {}) => string} */ () => {
	return `Map`
};

const es_map = /** @type {(inputs: {}) => string} */ () => {
	return `Mapa`
};

const fr_map = /** @type {(inputs: {}) => string} */ () => {
	return `Carte`
};

const hu_map = /** @type {(inputs: {}) => string} */ () => {
	return `Térkép`
};

const it_map = /** @type {(inputs: {}) => string} */ () => {
	return `Mappa`
};

const nl_map = /** @type {(inputs: {}) => string} */ () => {
	return `Kaart`
};

const pl_map = /** @type {(inputs: {}) => string} */ () => {
	return `Mapa`
};

const pt_map = /** @type {(inputs: {}) => string} */ () => {
	return `Mapa`
};

const sv_map = /** @type {(inputs: {}) => string} */ () => {
	return `Karta`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const map = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.map(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("map", locale)
	if (locale === "cs") return cs_map(inputs)
	if (locale === "da") return da_map(inputs)
	if (locale === "de") return de_map(inputs)
	if (locale === "en") return en_map(inputs)
	if (locale === "es") return es_map(inputs)
	if (locale === "fr") return fr_map(inputs)
	if (locale === "hu") return hu_map(inputs)
	if (locale === "it") return it_map(inputs)
	if (locale === "nl") return nl_map(inputs)
	if (locale === "pl") return pl_map(inputs)
	if (locale === "pt") return pt_map(inputs)
	return sv_map(inputs)
};